/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-26 17:04:41
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-06-23 16:44:48
 * @FilePath: \crm-product\src\views\performanceCalculation\views\import_statement\product_price\form\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Form, {
  formCreate,
} from '@/found/components/form';
import request from '@/found/utils/request';
import peopleAllocationList from './people_list.vue';

formCreate.component('peopleAllocationList', peopleAllocationList);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {

    };
  },
  async created() {
    await this.getFormRule('main-form');
  },
  methods: {
    // 设置规则
    setRule(item) {
      const v = item;
      return v;
    },
    // 渲染完成后执行
    formComplete() {
      request.post('/mdm/performancerargetreport/storemonthlydetail', {
        mainId: this.formConfig.row.id,
      }).then((res) => {
        if (res.success) {
          const {
            result,
          } = res;
          this.setValue({
            peopleAllocationList: result.data,
          });

          const peopleAllocationList2 = this.getRule('peopleAllocationList');
          peopleAllocationList2.props = {
            ...peopleAllocationList2.props,
            // mainTotal: (this.formConfig.row.unassignedAmount * 100 + (this.formComplete.row
            //   .assignedAmount || 0) * 100) / 100,
            mainTotal: this.formConfig.row.unassignedAmount,
          };
        }
      });
    },
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        const url = '/mdm/performancerargetreport/storemonthlyassign';
        const params = {
          // ...this.formConfig.row,
          id: this.formConfig.row.id,
          detailVos: formData.peopleAllocationList,
        };
        const allTotal = (this.formConfig.row.unassignedAmount * 100 + (this.formConfig.row
          .assignedAmount || 0) * 100) / 100;
        let total = 0;
        params.detailVos.forEach((v) => {
          total = (allTotal * 100 - v.totalAmount * 100) / 100;
        });
        if (total < 0) {
          this.$message({
            type: 'error',
            message: '分配业绩金额超出剩余可分配业绩金额!',
          });
          return;
        }
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
